'use client';

import { Typography } from '@mui/material';
import { usePageAction } from '@repo/hooks/usePageAction';
import { LinkViewed } from '@repo/segment/Analytics/LinkViewed';
import { SafeLinkWithFallback } from '../../../../../SafeLinkWithFallback';

type Props = {
  reviewLink?: string;
  institution?: {
    id: string;
    name?: string;
  };
  linkPosition?: number;
};

const nameTypography = (name: string | undefined) => (
  <Typography
    variant="textMediumBold"
    sx={{
      color: 'text.primary',
      fontSize: { xs: '14px', sm: '24px' },
      textDecoration: 'none',
      '&:hover': { textDecoration: 'underline' },
    }}
  >
    {name}
  </Typography>
);

export const ProductName = ({ reviewLink, institution, linkPosition }: Props) => {
  // TODO: Segment Standardization Cleanup
  const readReviewLinkClickEvent = usePageAction({
    actionDestinationUrl: reviewLink,
    actionName: 'nw_review_redirected',
    actionSection: 'banking_cd_institution_card',
    actionType: 'select',
    additionalAttributes: {
      institution_id: institution?.id,
      institution_nm: institution?.name,
    },
  });

  if (!reviewLink) {
    return nameTypography(institution?.name);
  }

  return (
    <LinkViewed
      entityName="nw_review_redirected"
      sectionName="banking_cd_institution_card"
      destinationUrl={reviewLink}
      linkCopy={institution?.name ?? ''}
      linkPosition={linkPosition}
      additionalAttributes={{
        institution_id: institution?.id,
        institution_nm: institution?.name,
      }}
    >
      {({ fireLinkClicked }) => (
        <SafeLinkWithFallback
          href={reviewLink}
          onClick={() => {
            readReviewLinkClickEvent();
            fireLinkClicked();
          }}
        >
          {nameTypography(institution?.name)}
        </SafeLinkWithFallback>
      )}
    </LinkViewed>
  );
};
